/* eslint-disable security/detect-object-injection */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { CurrencyInput, Loader, TextInput, withModalContext} from '@jutro/components';
import { getApdLobQuoteUrl } from '@xengage/gw-portals-url-js';
import { JobUtil } from '@xengage/gw-portals-util-js';
import { TranslatorContext } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { JobService, UserService, SubmissionService } from 'gw-capability-gateway';
import { screenReaderAnnounce } from 'premier-capability-hooks';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import appConfig from 'app-config';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import UnderwritingComponent from '../../Components/UnderwritingComponent/UnderwritingComponent';
import metadata from './Summary.metadata.json5';
import messages from './Summary.messages';
import gatewayMessages from '../../gateway.messages';
import styles from './Summary.module.scss';

class QuoteDetailsSummary extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            quoteDetailsData: PropTypes.shape({
                getQuoteSummaryCount: PropTypes.func,
                jobNumber: PropTypes.string.isRequired,
                loadQuoteSummary: PropTypes.shape({}),
                updateJobSummary: PropTypes.func
            })
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired
        }).isRequired
    };

    state = {
        showisContinueTransactionButton: false,
        canWithdraw: false,
        isLoading: true,
        isPrintSuccess: undefined,
        isPrintButtonDisabled: false
    };

    componentDidMount() {
        this.canWithdraw();
        this.getShowisContinueTransaction();

        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;

        const createTime = _.get(submission, 'createTime');
        const createdDate = new Date(createTime).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' });
        const effectiveDate = _.get(submission, 'policy.latestPeriod.effectiveDate');
        const policyInceptionDate = new Date(effectiveDate).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' });
        const status = _.get(submission, 'status');
        
        if (status === 'Quoted') {
            const totalPremium = _.get(submission, 'policy.latestPeriod.totalPremium');
            const taxesAndFees = _.get(submission, 'policy.latestPeriod.taxesAndFees');
            const totalCost = _.get(submission, 'policy.latestPeriod.totalCost');
            screenReaderAnnounce(`Quote Summary Details
            Created Date is ${createdDate}
            Policy Inception Date is ${policyInceptionDate}
            Status is ${_.get(submission, 'status')}
            Total Premium is ${totalPremium?.amount} ${totalPremium?.currency}
            Taxes And Fees is ${taxesAndFees?.amount} ${taxesAndFees?.currency}
            Total cost is ${totalCost?.amount} ${totalCost?.currency}`)
        } else {
            screenReaderAnnounce(`Quote Summary Details
            Created Date is ${createdDate}
            Policy Inception Date is ${policyInceptionDate}
            Status is ${_.get(submission, 'status')}`);
        }

    };

    getShowisContinueTransaction = async () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'createsubmission'
        };
        const showisContinueTransactionButton = await UserService.hasUserSystemPermission(
            permissionDTO,
            authHeader
        );

        this.setState({ showisContinueTransactionButton, isLoading: false });
    };

    onPrintQuote = async () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            },
            authHeader
        } = this.props;

        const translator = this.context;

        this.setState({ isLoading: true, isPrintSuccess: undefined, isPrintButtonDisabled: true });

        const res = await LoadSaveService.printQuoteDocument(submission.jobNumber, 'SubmissionQuote', authHeader)

         if(res === false){
            screenReaderAnnounce(translator(messages.printQuoteFailureMsg))
        } else {
            screenReaderAnnounce(translator(messages.printQuoteSuccessMsg))
        }

        this.setState({ isPrintSuccess: res, isLoading: false, isPrintButtonDisabled: false });
    };

    onPrintAppQuote = async () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            },
            authHeader
        } = this.props;
        const translator = this.context;

        this.setState({ isLoading: true, isPrintSuccess: undefined, isPrintButtonDisabled: true });
        
        const res = await LoadSaveService.printQuoteDocument(submission.jobNumber, 'ApplicationDocument', authHeader)
        
        if(res === false){
            screenReaderAnnounce(translator(messages.printQuoteFailureMsg))
        } else {
            screenReaderAnnounce(translator(messages.printQuoteSuccessMsg))
        }

        this.setState({ isPrintSuccess: res, isLoading: false, isPrintButtonDisabled: false });
    };

    canWithdraw = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;

        if (!_.isEmpty(submission)) {
            const translator = this.context;

            if (
                submission.status !== translator('typekey.PolicyPeriodStatus.Bound')
                && !submission.policy.issued
                && !submission.closeDate
            ) {
                this.setState({ canWithdraw: true });
            }
        }
    };

    onContinueTransaction = () => {
        const { lobQuoteURL } = appConfig;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            },
            history
        } = this.props;
        const productCode = _.get(submission, 'productCode');
        const postalCode = _.get(
            submission,
            'policy.account.accountHolder.primaryAddress.postalCode'
        );

        if (submission.jobNumber > 0) {
            if (!_.isNil(lobQuoteURL[productCode])) {
                const nextLocation = {
                    quoteentry: {
                        postalCode,
                        quoteID: submission.jobNumber
                    },
                    productCode
                };

                history.push(lobQuoteURL[productCode], nextLocation);
            } else if (!_.isNil(getApdLobQuoteUrl(productCode))) {
                const nextLocation = {
                    productCode,
                    accountId: submission.policy.account.publicID,
                    jobId: submission.publicID
                };

                history.push(getApdLobQuoteUrl(productCode), nextLocation);
            } else {
                JobUtil.openJobInXCenter(submission.jobNumber);
            }
        }
    };

    onWithdrawTransaction = () => {
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            },
            authHeader, 
            modalContext
        } = this.props;

        modalContext.showConfirm({
            title: messages.withdrawJob,
            message: `${translator(messages.sureWithDrawQuote)} ${submission.jobNumber}?`,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.withdraw,
            cancelButtonText: messages.cancel
        // eslint-disable-next-line consistent-return
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            JobService.withdrawJobByJobNumber(submission.jobNumber, authHeader).then(
                () => {
                    this.updateWithDrawQuote('Withdrawn', submission);
                },
                () => {
                    modalContext.showAlert({
                        title: gatewayMessages.modalError,
                        message: messages.failedWithdrawSubmission,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            );
        }, _.noop);
    };

    hasUwIssues = (uwIssues) => uwIssues.length > 0;

    getNotificationContent = () => {
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;
        const { showisContinueTransactionButton } = this.state;
        const content = {};

        if (
            submission
            && !['Bound', 'Quoted', 'Withdrawn'].includes(submission.statusCode)
            && !this.hasUwIssues(submission.underwritingIssues)
        ) {
            content.infoMessageTitle = translator(messages.quoteSuccessfullyStarted);
            content.infoMessageDescription = showisContinueTransactionButton
                ? translator(messages.continiueQuoteQizard)
                : translator(messages.mayWithdrawQuote);
        }

        if (
            submission
            && submission.statusCode === 'Quoted'
            && !this.hasUwIssues(submission.underwritingIssues)
        ) {
            content.infoMessageTitle = translator(messages.premiumQuoteCalculated);
            content.infoMessageDescription = showisContinueTransactionButton
                ? translator(messages.changeQuoteWizardToBind)
                : translator(messages.mayWithdrawQuote);
        }

        if (submission && submission.statusCode === 'Withdrawn') {
            content.infoMessageTitle = translator(messages.thisQuoteHasBeenWithDrawn);
            content.infoMessageDescription = '';
        }

        if (submission && submission.statusCode === 'Bound') {
            content.infoMessageTitle = translator(messages.quoteHasBeenBound);
            content.infoMessageDescription = '';
        }

        return {
            infoMessageTitle: content.infoMessageTitle,
            infoMessageDescription: content.infoMessageDescription,
            withDrawContent: messages.withdrawQuote,
            continueContent: messages.continueQuote
        };
    };

    getSubmissionToProceed = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;
        const { canWithdraw, showisContinueTransactionButton } = this.state;

        if (
            submission
            && (submission.statusCode === 'Withdrawn' || submission.statusCode === 'Bound')
        ) {
            return {
                isContinueTransaction: false,
                isWithdrawTransaction: false
            };
        }

        return {
            isContinueTransaction:
                showisContinueTransactionButton && canWithdraw && !submission.isEditLocked,
            isWithdrawTransaction: canWithdraw
        };
    };

    getPolicyLinkVisible = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;
        const policyNumber = _.get(submission, 'policy.latestPeriod.policyNumber');

        if (policyNumber) {
            return policyNumber !== 'Unassigned';
        }

        return false;
    };

    redirectToPolicy = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;
        const policyNumber = _.get(submission, 'policy.latestPeriod.policyNumber');

        return (
            <Link to={`/policies/${policyNumber}/summary`} className={styles.removeLinkStyle}>
                {policyNumber}
            </Link>
        );
    };

    getJobStatus = (job) => {
        const translator = this.context;

        if (job.policy) {
            if (job.policy.issued) {
                return translator(gatewayMessages.issued);
            }

            if (job.status === 'Not-taken') {
                return translator(gatewayMessages.notTaken);
            }
        }

        return job.status;
    };

    getStatusInfo = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;
        const translator = this.context;
        const submissionStatus = this.getJobStatus(submission);

        if (submissionStatus.toLowerCase() === 'bound' && submission.policy.issued) {
            return translator('gateway.directives.JobSummary.Issued');
        }

        return submissionStatus;
    };

    updateWithDrawQuote = (jobStatusCode, submission) => {
        const translator = this.context;
        const status = translator({
            id: `typekey.PolicyPeriodStatus.${jobStatusCode}`,
            defaultMessage: jobStatusCode
        });

        _.set(submission, 'status', status);
        _.set(submission, 'statusCode', jobStatusCode);
        this.updateJobSummary(submission);
    };

    updateJobSummary = (submission) => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { updateJobSummary, getQuoteSummaryCount }
            }
        } = this.props;

        if (updateJobSummary) {
            updateJobSummary(submission);
        }

        if (getQuoteSummaryCount) {
            getQuoteSummaryCount();
        }
    };

    render() {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission }
            }
        } = this.props;

        const { isLoading, isPrintSuccess } = this.state;

        if (_.isEmpty(submission)) {
            return <Loader loaded={!isLoading} />;
        }

        const effectiveDate = _.get(submission, 'policy.latestPeriod.effectiveDate');
        const createTime = _.get(submission, 'createTime')

        const overrides = {
            quoteNotification: {
                notificationContent: this.getNotificationContent(),
                transactionVisibleActions: this.getSubmissionToProceed()
            },
            underwritingTable: {
                job: submission,
                continueJob: this.getSubmissionToProceed(),
                jobService: SubmissionService,
                onUpdateJobSummary: this.updateJobSummary
            },
            policyInfoLink: {
                visible: this.getPolicyLinkVisible(),
                value: this.redirectToPolicy()
            },
            detailGridTotalColumn: {
                visible: submission.statusCode === 'Quoted'
            },
            producerCodeOfRecordOrgId: {
                value: `${_.get(
                    submission,
                    'policy.latestPeriod.producerCodeOfRecordOrg'
                )} (${_.get(submission, 'policy.latestPeriod.producerCodeOfRecord')})`
            },
            producerOfServiceId: {
                value: `${_.get(
                    submission,
                    'policy.latestPeriod.producerCodeOfServiceOrg'
                )} (${_.get(submission, 'policy.latestPeriod.producerCodeOfService')})`
            },
            summaryStatusdDataId: {
                value: this.getStatusInfo()
            },
            messageInfoLableId: {
                message: !_.isUndefined(isPrintSuccess) && isPrintSuccess ? messages.printQuoteSuccessMsg : messages.printQuoteFailureMsg,
                type: !_.isUndefined(isPrintSuccess) && isPrintSuccess ? 'info': 'error',
                visible: !_.isUndefined(isPrintSuccess),
                isDismissable: false
            },
            printButtonGroup: {
                visible: ['Quoted', 'Issued', 'Bound'].includes(_.get(submission, 'statusCode'))
            },
            printQuoteButtonId: {
                disabled: this.state?.isPrintButtonDisabled
            },
            printAppButtonId: {
                disabled: this.state?.isPrintButtonDisabled
            },
            summaryCreatedDataId: {
                value: new Date(createTime).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' })
            },
            summaryPolicyInceptionId: {
                value: new Date(effectiveDate).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' })
            },
            totalPremiumId: {
                value: {... (_.get(submission, 'policy.latestPeriod.totalPremium')), 
                    currency: (_.get(submission, 'policy.latestPeriod.totalPremium')?.currency?.toUpperCase())}
            },
            taxesAndFeesId: {
                value: {... (_.get(submission, 'policy.latestPeriod.taxesAndFees')), 
                    currency: (_.get(submission, 'policy.latestPeriod.taxesAndFees')?.currency?.toUpperCase())}
            },
            totalCostId: {
                value: {... (_.get(submission, 'policy.latestPeriod.totalCost')), 
                    currency: (_.get(submission, 'policy.latestPeriod.totalCost')?.currency?.toUpperCase())}
            }
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                underwritingcomponent: UnderwritingComponent,
                TextInput,
                CurrencyInput
            },
            resolveCallbackMap: {
                onContinueTransaction: this.onContinueTransaction,
                onWithdrawTransaction: this.onWithdrawTransaction,
                redirectToPolicy: this.redirectToPolicy,
                onPrintAppQuote: this.onPrintAppQuote,
                onPrintQuote: this.onPrintQuote
            }
        };
        // eslint-disable-next-line arrow-body-style
        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, submission, id, path, overrides);
        };

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submission}
                overrideProps={overrides}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                resolveValue={readValue}
            />
        );
    }
}

export default withAuthenticationContext(withModalContext(QuoteDetailsSummary));
